import React, { Component } from "react";
import * as customersInfo from './modules/customers/CustomerList.json';
export const AppContext = React.createContext();

const defaultCustomerSelected = {
  productIds: "all",
  name: null,
  customer: "none",
  customerId: null
};
const defaultCustomer = { value: "none", label: "Ninguno" };

class AppState extends Component {
  constructor(props) {
    super(props);
    let customerObjects = {};
    let customerList = [];
    customerList.push(defaultCustomer);

    customersInfo.list.forEach(customerInfo => {
      customerList.push({ value: customerInfo.customerId, label: customerInfo.customer });
      customerInfo.productIds = customerInfo.productIds.replace(/\s/g, ''); //remove white space
      if (customerInfo.productIds !== 'all' && customerInfo.productIds.indexOf(',') !== -1 ) {
        customerInfo.productIds = customerInfo.productIds.split(',').map(function(prod) {
          return parseInt(prod, 10);
        });
      } else {
      //} else if (customerInfo.productIds !== 'all') { //TODO ver como guardamos el all prods
        customerInfo.productIds = [parseInt(customerInfo.productIds, 10)];
      }
      customerObjects[customerInfo.customerId] = customerInfo;
    });

    this.state = { customerList, customerObjects, selected: defaultCustomerSelected };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    let selected = this.state.customerObjects[event.target.value]
      ? this.state.customerObjects[event.target.value]
      : defaultCustomerSelected;
    // console.log(selected);

    this.setState({ selected });
  }

  handleSubmit(event) {
    //no hace falta me parece, para pensar
    event.preventDefault();
  }

  render() {
    return (
      <AppContext.Provider
        value={{ ...this.state, handleChange: this.handleChange }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppState;
